export class Notification {
  id: number;
  date: string;
  title: string;
  message: string;
  type: number;
  markedAsRead: boolean;
  markedAsReadDate: string;
  markedAsDeleted: boolean;
  markedAsDeletedDate: string;
  fromSupplierId: number;
  fromAgentId: number;
  fromUserAccountId: number;
  metadata: string;
  toSupplier: number[];
  toAgent: number[];
  toUserAccount: number[];
}



// WEBPACK FOOTER //
// ./src/app/shared/api/model/notification.ts